import React from "react";
import "../ConfirmPopup/ConfirmPopup.css";
import CancelBtn from "../CustomButtons/CancelBtn/CancelBtn";

interface ConfirmPopupProps {
  isOpen: boolean;
  title?: string;
  message?: React.ReactNode;   
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: string;
  cancelColor?: string;
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({
  isOpen,
  title = "Confirmation",
  message = "Are you sure?",
  onConfirm,
  onCancel,
  confirmLabel = "Yes",
  cancelLabel = "No",
  confirmColor = "#e53e3e",
  cancelColor,
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <div className="popup-header">
          <h3>{title}</h3>
          <CancelBtn CancelBtnClick ={onCancel}/>
        </div>

        <div className="popup-body">
          <p>{message}</p>
        </div>

        <div className="popup-footer">
          <button
            className="cancel-btn"
            onClick={onCancel}
            style={cancelColor ? { backgroundColor: cancelColor } : undefined}
          >
            {cancelLabel}
          </button>
          <button
            className="confirm-btn"
            onClick={onConfirm}
            style={{ backgroundColor: confirmColor }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
